<template>
  <AuthLayout
    eyebrow="Passwort"
    title="Zugang sicher wiederherstellen"
    intro="Fordern Sie einen Wiederherstellungslink an, um Ihr Passwort sicher zurückzusetzen."
    card-title="Passwort vergessen"
    card-intro="Geben Sie die E-Mail-Adresse Ihres Kontos ein. Wenn das Konto aktiv ist, senden wir Ihnen die weiteren Schritte zu."
    :aside-list="[
      'Link direkt per E-Mail erhalten',
      'Passwort sicher neu vergeben',
      'Danach direkt wieder im Kundenbereich anmelden'
    ]"
  >
    <Form @submit="submit" v-slot="{ errors }" :validation-schema="schema">

      <div class="form-floating mb-3">

        <Field type="text" as="input" id="email" name="email" class="form-control"
               :class="{'is-invalid': errors.email}" autocomplete="off" aria-required="true"
        />
        <label for="email">E-Mail</label>
        <ErrorMessage name="email" />
        <div v-if="showSuccess" class="alert alert-success mt-3">
          Anfrage erfolgreich übermittelt. Sofern die E-Mail-Adresse korrekt und das Benutzerkonto aktiv ist, erhalten Sie weitere Anweisungen via E-Mail.
        </div>
      </div>
      <MatchaWidget v-model="matchaToken" />
      <div v-if="errorMessage" class="alert alert-danger py-2" role="alert">{{ errorMessage }}</div>
      <button type="submit" class="btn btn-primary mt-3 btn-block">Wiederherstellungslink senden</button>
    </Form>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/layout/AuthLayout.vue";
import Yup from "@/yup";
import {useUserStore} from "@/stores/user";
import { Form, Field, ErrorMessage } from "vee-validate";
import MatchaWidget from "@/components/auth/MatchaWidget.vue";
import {matchaError} from "@/scripts/matcha";
export default {
  name: "PasswordReset",
  components: {
    AuthLayout,
    Form,
    Field,
    ErrorMessage,
    MatchaWidget
  },
  data() {
    return {
      schema: Yup.object({
        email: Yup.string().required(),
      }),
      showSuccess: false,
      matchaToken: '',
      errorMessage: ''
    }
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  methods: {
    submit(values) {
      this.errorMessage = ''
      this.userStore.apiAuthResetPassword(values, this.matchaToken).then(( ) => {
        this.showSuccess = true
      }).catch(error => {
        this.errorMessage = matchaError(error)
        console.log(error)
      });
    }
  }
}
</script>
